<template>
  <div id="app">
    <el-container>
      <el-header id="rowLogo" class="main-header" v-show="UserStore.signedIn">
        <el-row :gutter="20">
          <el-col :span="4">
            <div id="divLogo" class="logo">
              <a :href="appUrl">
              <img
                id="imgLogo"
                class="logo"
                src="./assets/LogoPIM.png"
                alt="iPIM-Pro logo"
              />
            </a>
            </div>
          </el-col>
          <el-col :xs="2" :sm="6" :md="8" :lg="11" :xl="13"></el-col>
          <el-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3" justify="end">
            <el-badge :value="TareasStore.NumTareasPendientes" class="item">
            <el-button
              round
              class="buttonIdilia"
              @click="ShowDialogTareasPendientes(true)"
            >
              Mis tareas
          </el-button>
          </el-badge>
          <DialogTareasPendientes 
          :visible="dialogTareasPendientesVisible"
          @Show-dialog-tareas-pdtes="ShowDialogTareasPendientes" />
          </el-col>
          <el-col :xs="9" :sm="8" :md="7" :lg="5" :xl="3" justify="end">
            <!--<div class="login">
               <AutoLogin /> 
            </div>-->
            <div class="login">
              <mgt-login
                v-pre
                id="mgtLogin"
              >
                <!-- <template > -->
                <div data-type="signed-out">
                  Sign In
                </div>
                <!-- </template> -->
              </mgt-login>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-main class="main-body">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref, watch } from "vue";
import { useUserStore } from "./store/UserStore";
import { useCommonStore } from "./store/CommonStore";
import { useFasesStore } from "./store/FaseStore";
// import AutoLogin from './components/AutoLogin.vue';
import { useClientesStore } from "./store/ClientesStore";
import { useTareasStore } from "./store/TareasStore";
const DialogTareasPendientes = defineAsyncComponent(
  () => import("./components/DialogTareasPendientes.vue")
);
const UserStore = useUserStore();
const CommonStore = useCommonStore();
const FasesStore = useFasesStore();
const ClientesStore = useClientesStore();
const TareasStore = useTareasStore()
const signedIn = computed(() => UserStore.signedIn);
const appUrl = window.location.origin
// const windowWidth = ref(window.innerWidth)
const dialogTareasPendientesVisible = ref(false)
watch(signedIn, async (signedIn) => {
  if (signedIn) {
    // Cargar datos
    await FasesStore.GetFases();
    await CommonStore.GetDatosMaestros();
    ClientesStore.GetClientes();
  }
});

UserStore.ConfigureProvider()
const ShowDialogTareasPendientes = (value: boolean) => {
  dialogTareasPendientesVisible.value = value;
};
</script>

<style lang="scss">

@font-face {
  font-family: "Gotham";
  src:
    local("Gotham"),
    url(./fonts/Gotham-Book.otf) format("truetype");
}
#app {
  font-family: "Gotham", Helvetica, Arial, sans-serif;
  font-size: small;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fff3db;
  min-height: 100vh; // Asegura que el contenedor principal ocupe al menos el 100% de la altura del viewport
  display: flex;
  flex-direction: column;
}

.el-container {
  flex: 1; // Permite que el contenedor principal se expanda para ocupar el espacio disponible
}

.main-body {
  padding: 10px !important;
  flex: 1; // Permite que el cuerpo principal se expanda para ocupar el espacio disponible
}
.item {
  margin-top: 20px;
  margin-right: 30px;
}

@import "./common/style.css";
</style>
